import * as React from 'react';
import wizardCss from './wizard.css';
import { IDeviceGroupOptions } from '../../../../store/wizard-store';
import { IDeviceGroupTableProps } from './commission-interface';
import {
    AdvanceEditableTable,
    SelectFormItem,
    IEditableTableColumn,
    IEditableTableProps,
    EditableContext,
    Typography,
} from 'ui-lib';
import { CheckBoxFormItem } from 'ui-lib/components/forms/items/check-box-form-item';
import { useWelcomePackCommissioning } from 'hooks/use-wp-commissioning.hook';
import { observer } from 'mobx-react';

interface IRecordProps {
    record: IDeviceGroupOptions;
}
export const SelectDeviceGroupsWrapper = observer((props: IDeviceGroupTableProps) => {
    const dataSource = props.data.dataSource;
    const tableDataSource = !dataSource ? [] : [dataSource];

    const { latestActiveWelcomePack, loading, setSelectedWelcomePack } = useWelcomePackCommissioning({
        accountId: props.clientAccountId,
        onWelcomePackChange: props.onUseWelcomePackChange,
    });

    const secondColumnRenderItem = (componentProps: IRecordProps) => {
        const code = 'deviceGroupName';
        const record: IDeviceGroupOptions = componentProps.record;
        const onChange = (value, option) => props.onDeviceGroupChange(value);
        const dataSource = record.deviceGroupNames || [];
        const selected = dataSource.length > 0 ? dataSource[0].value : undefined;
        const form = React.useContext(EditableContext);
        React.useEffect(() => {
            onChange(selected, {});
            form.validateFields([code]);
        }, []);

        return (
            <div key={'device-group-div'}>
                <SelectFormItem
                    isRequired={true}
                    onChange={onChange}
                    code={code}
                    label='Device group name'
                    dataSource={dataSource}
                    selectedValue={selected}
                    placeholder='Device Group'
                />
                <CheckBoxFormItem
                    code='useWelcomePack'
                    label='Use Welcome Pack for this commissioning'
                    disabled={!latestActiveWelcomePack || props.selectedPlatform?.code !== 'ASSURE'}
                    checked={!!props.selectedWelcomePackId}
                    loading={loading}
                    onChange={(e) => {
                        const checked = e.target.checked;
                        setSelectedWelcomePack(checked ? latestActiveWelcomePack : null);
                    }}
                />
                {!latestActiveWelcomePack && !loading && (
                    <Typography.Text italic>Configure Welcome Pack to start using it!</Typography.Text>
                )}
            </div>
        );
    };

    const indexesColumn = {
        code: 'indexes',
        title: '#',
        dataIndex: 'index',
    };

    const deviceGroupNameColumn: IEditableTableColumn = {
        code: 'deviceGroupName',
        title: 'Device group name',
        dataIndex: 'deviceGroupName',
        component: secondColumnRenderItem,
    };

    const tableProps: IEditableTableProps = {
        columns: [indexesColumn, deviceGroupNameColumn],
        pagination: false,
        dataSource: tableDataSource?.map((item, index) => ({ index: index + 1, ...item })),
        className: wizardCss.table,
    };

    return (
        <React.Fragment>
            <AdvanceEditableTable
                title='Device group'
                loadingState={props.data.loading}
                toolbar={{
                    extraItems: [
                        <Typography.Text key='selected-platform'>
                            Platform: <Typography.Text strong>{props.selectedPlatform?.name || 'N/A'}</Typography.Text>
                        </Typography.Text>,
                    ],
                }}
                table={tableProps}
            />
        </React.Fragment>
    );
});
